import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["frame"];
  static values = {
    loadMoreUrl: { type: String, default: "" },
    hideAllUrl: { type: String, default: "" }
  };

  loadAll() {
    this.frameTarget.src = this.loadMoreUrlValue;
  }

  hideAll() {
    this.frameTarget.src = this.hideAllUrlValue;
  }
}
